// 统一管理本项目，本地数据的key
export const localStorageManage = {
    // 用户登录标识
    'token': 'TOKEN',
    // 用户信息
    'user': 'USER',
    // 机器人工作状态信息
    'rWorkStatusNameList': 'R WORK STATUS NAME LIST',
    // 项目工作状态信息
    'pWorkStatusNameList': 'P WORK STATUS NAME LIST',
    // 登录信息
    'loginInfo': 'LOGIN INFO'
}
// 清空本项目中的本都存储
export const localStorageClean = () => {
    let keys = Object.keys(localStorageManage);
    for (let i = 0; i < keys.length; i++) {
        if (keys[i] !== 'loginInfo') {
            localStorage.removeItem(localStorageManage[keys[i]])
        }
    }
}